const pages = {
	main: {
		title: 'Main',
		titleClass: 'page__title page__title--main',
		contentClass: 'page__content page__content--main',
		sidebarClass: ''
	},
	aboutUs: {
		title: 'About us',
		titleClass: 'page__title page__title--aboutus',
		contentClass: 'page__content page__content--aboutus',
		sidebarClass: ''
	},
	faq: {
		title: 'FAQ',
		titleClass: 'page__title page__title--faq',
		contentClass: 'page__content page__content--faq',
		sidebarClass: ''
	},
	support: {
		title: 'Support',
		titleClass: 'page__title page__title--support',
		contentClass: 'page__content page__content--support',
		sidebarClass: 'page__content-sidebar'
	},
	archive: {
		title: 'Archive',
		titleClass: 'page__title page__title--cameras',
		contentClass: 'page__content page__content--cameras',
		sidebarClass: ''
	},
	search: {
		title: 'Search results',
		titleClass: 'page__title page__title--search',
		contentClass: 'page__content page__content--search',
		sidebarClass: ''
	},
	contactUs: {
		title: 'Contact us',
		titleClass: 'page__title page__title--contact',
		contentClass: 'page__content page__content--contact',
		sidebarClass: 'page__content--contact-sidebar'
	}
};

export default pages;


// WEBPACK FOOTER //
// ./src/config/pages.js